export const changeTabs = (tab, schoolList, schoolTab) => {
    if(document.getElementById('timesheet-tab') && document.getElementById('invoices-tab')){
        if(tab === 'timesheets') {
            document.getElementById('timesheet-tab').style.color = '#000'
            document.getElementById('timesheet-tab').style.borderBottom = '3px solid rgba(0, 94, 255, 1)'
            document.getElementById('timesheet-tab').style.fontWeight = '800'
            document.getElementById('invoices-tab').style.color = 'rgb(161, 161, 161)'
            document.getElementById('invoices-tab').style.fontWeight = '200'
            document.getElementById('invoices-tab').style.borderBottom = '3px solid transparent'
            document.getElementById('unbilled-tab').style.color = 'red'
            document.getElementById('unbilled-tab').style.fontWeight = '200'
            document.getElementById('unbilled-tab').style.borderBottom = '3px solid transparent'
        } else if (tab === 'invoices') {
            document.getElementById('invoices-tab').style.color = '#000'
            document.getElementById('invoices-tab').style.borderBottom = '3px solid rgba(0, 94, 255, 1)'
            document.getElementById('invoices-tab').style.fontWeight = '800'
            document.getElementById('timesheet-tab').style.color = 'rgb(161, 161, 161)'
            document.getElementById('timesheet-tab').style.fontWeight = '200'
            document.getElementById('timesheet-tab').style.borderBottom = '3px solid transparent'
            document.getElementById('unbilled-tab').style.color = 'red'
            document.getElementById('unbilled-tab').style.fontWeight = '200'
            document.getElementById('unbilled-tab').style.borderBottom = '3px solid transparent'
        } else if (tab === 'unbilled') {
            document.getElementById('unbilled-tab').style.color = 'red'
            document.getElementById('unbilled-tab').style.borderBottom = '3px solid red'
            document.getElementById('unbilled-tab').style.fontWeight = '800'
            document.getElementById('invoices-tab').style.color = 'rgb(161, 161, 161)'
            document.getElementById('invoices-tab').style.fontWeight = '200'
            document.getElementById('invoices-tab').style.borderBottom = '3px solid transparent'
            document.getElementById('timesheet-tab').style.color = 'rgb(161, 161, 161)'
            document.getElementById('timesheet-tab').style.fontWeight = '200'
            document.getElementById('timesheet-tab').style.borderBottom = '3px solid transparent'
        }
    }

    if(tab === 'timesheets' || tab === 'invoices') {
        for(let i = 0; i < schoolList.length; i++) {
            if(document.getElementById(`${schoolList[i]}-tab`)) {
                document.getElementById(`${schoolList[i]}-tab`).style.color = 'rgb(130, 130, 130)'
                document.getElementById(`${schoolList[i]}-tab`).style.fontWeight = '200'
                document.getElementById(`${schoolList[i]}-tab`).style.borderBottom = '3px solid transparent'
            }
        }
        document.getElementById(`${schoolTab}-tab`).style.color = '#000'
        document.getElementById(`${schoolTab}-tab`).style.borderBottom = '3px solid rgba(33, 150, 33, 0.548)'
        document.getElementById(`${schoolTab}-tab`).style.fontWeight = '800'
    }
}

export const enterHoverAnimation = (id, theTab, tab, schoolTab) => {
    if(theTab !== tab && theTab !== schoolTab) {
        document.getElementById(id).style.color = '#000'
        document.getElementById(id).style.borderBottom = '3px solid rgba(200, 200, 200, 0.6)'
    }
    if(theTab === 'unbilled' && theTab !== tab) {
        document.getElementById(id).style.color = 'red'
        document.getElementById(id).style.borderBottom = '3px solid rgba(200, 200, 200, 0.6)'  
    }
}

export const leaveHoverAnimation = (id, theTab, tab, schoolTab) => {
    if(theTab !== tab && theTab !== schoolTab) {
        document.getElementById(id).style.color = 'rgb(161, 161, 161)'
        document.getElementById(id).style.borderBottom = '3px solid transparent'
    }
    if(theTab === 'unbilled' && theTab !== tab) {
        document.getElementById(id).style.color = 'red'
        document.getElementById(id).style.borderBottom = '3px solid transparent'
    }
}

export const massCheck = (isChecked) => {
    let theBoxes = document.getElementsByClassName('student-checkbox')
    if(isChecked) {
        for(let i = 0; i < theBoxes.length; i++){
            theBoxes[i].checked = true
        }
    } else {
        for(let i = 0; i < theBoxes.length; i++){
            theBoxes[i].checked = false
        }
    }
}

export const copyAttempt = () => {
    let theList = ''
    let theBoxes = document.getElementsByClassName('student-checkbox')
    for(let i = 0; i < theBoxes.length; i++) {
        if(theBoxes[i].checked === true) {
            theList = theList + ' ' + theBoxes[i].value + ';'
        }
    }
    navigator.clipboard.writeText(theList)
    setTimeout(function(){
        alert("Emails have been copied to you clipboard")
        for(let i = 0; i < theBoxes.length; i++) {
            theBoxes[i].checked = false
        }
    }, 0)
}